// extracted by mini-css-extract-plugin
export default {"checkBox":"checkbox_checkBox__Y0s9-"};